import { getConfig } from '@/config/config.ts';
import type { LegalEntity } from '@/model/LegalEntity.ts';
import type { RootInAgent } from '@/model/RootInAgent.ts';
import { createApi } from '@reduxjs/toolkit/query/react';
import { webApiResponseBaseQuery } from './webApiResponseBaseQuery.ts';
import type { Failure } from './WebApiResponse.ts';

const prefixUrl = getConfig().prefixUrl ?? '';

export const agentRootApi = createApi({
  reducerPath: 'agentRootApi',
  keepUnusedDataFor: 3_600, // By defaut keep query data 1h even if unused
  baseQuery: webApiResponseBaseQuery,
  endpoints: (builder) => ({
    getAgentRoots: builder.query<{data: RootInAgent[], failures: Failure[]}, LegalEntity>({
      query: (entity: LegalEntity) => ({
        method: 'GET',
        url: `${prefixUrl}/agents/roots`,
        params: {
          legalEntity: entity
        },
      }),
      keepUnusedDataFor: 30, // keep unused results for 30s in cache
      transformResponse: ({ data, failures }) => ({ data: data as RootInAgent[], failures }),
    }),
    getAgentDesks: builder.query<{data: RootInAgent[], failures: Failure[]}, LegalEntity>({
      query: (entity:LegalEntity) => ({
        method: 'GET',
        url: `${prefixUrl}/agents/desks`,
        params: {
          legalEntity: entity
        },
      }),
      keepUnusedDataFor: 30, // keep unused results for 30s in cache
      transformResponse: ({ data, failures }) => ({ data: data as RootInAgent[], failures }),
    }),
  }),
});
export const {
  useGetAgentRootsQuery,
  useLazyGetAgentRootsQuery,
  useGetAgentDesksQuery,
  useLazyGetAgentDesksQuery,
} = agentRootApi;
